import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useGetBookingForAccountQuery } from '#api/bookingApi.slice.ts';
import { useFeatureToggle } from '#configuration/featureFlags/useFeatureToggle.ts';
import { hasBookingState } from '#domain/bookingState.ts';
import { routes } from '#routes/routes.ts';

export const useHandleBookingState = () => {
    const { isLoading, data: bookingData, error, refetch } = useGetBookingForAccountQuery(undefined);
    const showOnlyTourServiceTours = useFeatureToggle('showOnlyTourServiceTours', false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (error || !bookingData) {
            return;
        }

        if (showOnlyTourServiceTours && !location.pathname.includes(routes.TOURSERVICE)) {
            navigate(routes.TOURSERVICE + location.search);
        }

        if (location.pathname.includes(routes.TOURSERVICE)) {
            return;
        }

        const hasConfirmedBooking = hasBookingState(bookingData, 'CONFIRMED');

        if (!hasConfirmedBooking && !location.pathname.includes(routes.WELCOME)) {
            navigate(routes.WELCOME + location.search);
        } else if (hasConfirmedBooking && location.pathname.includes(routes.WELCOME)) {
            navigate(`/${location.search}`);
        }
    }, [isLoading, bookingData, location, error]);

    return { isLoading, error, refetch };
};
